import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { Toast } from "antd-mobile";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { collectApi } from "../../api/collect-api";
import { contractApi } from "../../api/contract-api";
import { financeApi } from "../../api/finance-api";
import { homeApi } from "../../api/home-api";
import { huobiApi } from "../../api/huobi";
import { leverApi } from "../../api/lever-api";
import { WSContext } from "../../router/router";
import { getText } from "../../utils/util";
import CoinPopup from "./components/coinpopup";
import DataList from "./components/datalist";
import OrderList from "./components/orderlist";
import OrderPopup from "./components/orderpopup";
import TopBar from "./components/topbar";
import TopBuy from "./components/topbuy";
import TopText from "./components/topText";

// 定义合约设置信息接口
interface HysetInfo {
  hyTime: number[] | string; // 可以是字符串或数字数组
  hyTzed: number[] | string;
  hyYkbl: number[] | string;
  usdtcnyrate?: number;
  [key: string]: any; // 允许其他属性
}

export default function Lever() {
  //贸易
  const [userInfoData, setUserInfoData] = useState({});
  const [companyData, setCompanyData] = useState({} as any);
  const [iscollect, setiscollect] = useState(false);
  const [orderindex, setorderindex] = useState(1);
  const [isShowCoin, setIsShowCoin] = useState(false);
  const [isShowOrder, setIsShowOrder] = useState(false);
  ///
  const uid = localStorage.getItem("uid");
  const { t: translate } = useTranslation();
  const [daojishi, setDaojis] = useState(60);
  const [sendData, setSendData] = useState({});
  const [isShow, setIsShow] = useState(false);
  const [nowTab, setNowTab] = useState("");
  const [hysetInfo, setHysetInfo] = useState<HysetInfo>({} as HysetInfo);
  const [userInfo, setuserInfo] = useState({} as any);
  const [huobigetHistory, sethuobigetHistory] = useState([] as any[]);
  const [ctmarketlist, setCtmarketlist] = useState([] as any[]);
  const [collectlist, setcollectlist] = useState([] as any[]);
  const [leverorders, setleverorders] = useState([] as any[]);
  const [leverSet1, setLeverSet1] = useState([] as any[]);
  const [leverSet2, setLeverSet2] = useState([] as any[]);
  const [leverage, setLeverage] = useState([] as any[]);
  const location = useLocation();
  const param = useParams();
  let timer: any;
  const [hyorders, sethyorders] = useState([] as any[]);
  const [coinListData, setCoinListData] = useContext(WSContext);
  //贸易
  const [type, setType] = useState(1);

  // 添加状态来替代window对象上的属性
  const [selectedLeverageIndex, setSelectedLeverageIndex] = useState(0);
  const [selectedLeverage, setSelectedLeverage] = useState(0);
  const [selectedProfitIndex, setSelectedProfitIndex] = useState(0);
  const [selectedProfit, setSelectedProfit] = useState(0);
  const [selectedLossIndex, setSelectedLossIndex] = useState(0);
  const [selectedLoss, setSelectedLoss] = useState(0);
  const [winPrice, setWinPrice] = useState("--");
  const [lossPrice, setLossPrice] = useState("--");
  const [boomPrice, setBoomPrice] = useState("--");
  const [buyAmount, setBuyAmount] = useState("");

  //加载用户资产
  const loadUserCoinData = async () => {
    const data = await financeApi.userCoin({ uid });
    if (data.ok) {
      setuserInfo(data.data);
    }
  };

  //平仓
  const closeorder = async (lid, num, ploss) => {
    const data = await leverApi.closeorderNew({ uid, lid, num, ploss });
    if (data.ok) {
      Toast.show({ content: data.msg });
    } else {
      Toast.show({ content: data.msg });
    }
    loadData();
  };

  const loadcollectlistData = async () => {
    const data = await collectApi.list({ uid, pageNum: 1, pageSize: 100 });
    if (data.ok) {
      setcollectlist(data.data);
    }
  };
  //加仓
  const addnum = async (param) => {
    const data = await leverApi.addnum({ uid, ...param });
    if (data.ok) {
      Toast.show({ content: data.msg });
    } else {
      Toast.show({ content: data.msg });
    }
    loadData();
  };

  //减仓
  const strutcnum = async (param) => {
    const data = await leverApi.strutcnum({ uid, ...param });
    if (data.ok) {
      Toast.show({ content: data.msg });
    } else {
      Toast.show({ content: data.msg });
    }
    loadData();
  };

  //设置亏损盈利值
  const editLossWin = async (param) => {
    const data = await leverApi.editLossWin({ uid, ...param });
    if (data.ok) {
      Toast.show({ content: data.msg });
    } else {
      Toast.show({ content: data.msg });
    }
    loadData();
  };
  //订单信息
  const loadLeverListData = async () => {
    const data = await leverApi.list({ uid, pageNum: 1, pageSize: 100 });
    if (data.ok) {
      setleverorders(data.data.records);
    }
  };

  //订单信息
  const loadhuobigetHistoryData = async () => {
    if (!nowTab) {
      return;
    }
    const data = await huobiApi.getHistory(nowTab, 20);
    if (data) {
      sethuobigetHistory(data.data);
    }
  };

  //市场信息
  const loadctmarketlistData = async () => {
    const data = await homeApi.ctmarketlist({ pageNum: 1, pageSize: 100 });
    if (data.ok) {
      const list = data.data.records;
      list.sort((d, e) => d.sort - e.sort);
      setCtmarketlist(list);
    }
  };
  //设置
  const loadhysetInfoData = async () => {
    const data = await contractApi.hysetInfo();
    if (data.ok) {
      let hysetInfoT = data.data;
      let hyTimes = hysetInfoT?.hyTime.split(",");
      let hyTzeds = hysetInfoT?.hyTzed.split(",");
      let hyYkbls = hysetInfoT?.hyYkbl.split(",");
      for (let index = 0; index < hyTimes.length; index++) {
        let hyTime = hyTimes[index];
        let hyTzed = hyTzeds[index];
        let hyYkbl = hyYkbls[index];
        hyTimes[index] = parseInt(hyTime);
        hyTzeds[index] = parseInt(hyTzed);
        hyYkbls[index] = parseInt(hyYkbl);
      }
      hysetInfoT.hyTime = hyTimes;
      hysetInfoT.hyTzed = hyTzeds;
      hysetInfoT.hyYkbl = hyYkbls;
      setHysetInfo(hysetInfoT);
    }
  };

  //加载倍数
  const getTwLeverage = async () => {
    // if (!nowTab) {
    //   return;
    // }
    // const data = await leverApi.getTwLeverage({
    //   symbol: `${nowTab.toUpperCase()}/USDT`,
    // });
    // if (data.ok) {
    //setLeverage(data.data);
    setLeverage([
      {
        num: 3,
      },
      {
        num: 5,
      },
      {
        num: 10,
      },
      {
        num: 20,
      },
      {
        num: 50,
      },
    ]);
    // }
  };

  //加载上下限制
  const getTwLeverSet = async (type) => {
    if (!nowTab) {
      return;
    }
    const data = await leverApi.getTwLeverSet({
      symbol: `${nowTab.toUpperCase()}/USDT`,
      type,
    });
    if (data.ok) {
      if (type === 1) {
        setLeverSet1(data.data);
      }
      if (type === 2) {
        setLeverSet2(data.data);
      }
    }
  };

  //下单
  const buyCoin = async (dataInfo) => {
    dataInfo.uid = uid;
    const data = await leverApi.creatorderNew(dataInfo);
    if (data.ok) {
      Toast.show({ content: data.msg });
      setIsShowOrder(false);
    } else {
      Toast.show({ content: data.msg });
    }
    loadData();
  };

  const loadData = async () => {
    loadcollectlistData();
    loadUserCoinData();
    loadLeverListData();
  };

  const loadSetData = async () => {
    loadhuobigetHistoryData();
    getTwLeverage();
    getTwLeverSet(1);
    getTwLeverSet(2);
    loadhysetInfoData();
    loadctmarketlistData();
  };

  const loadiscollectData = async () => {
    const data = await collectApi.sel({ uid, coinname: param.name });
    if (data.ok) {
      if (data.data) {
        setiscollect(true);
      } else {
        setiscollect(false);
      }
    }
  };

  const collectAdd = async () => {
    const data = await collectApi.add({ uid, coinname: param.name });
    if (data.ok) {
      Toast.show(translate(getText("添加自选成功")));
    }
    loadiscollectData();
  };

  const collectDel = async () => {
    const data = await collectApi.del({ uid, coinname: param.name });
    if (data.ok) {
      Toast.show(translate(getText("取消自选成功")));
    }
    loadiscollectData();
  };

  //加载当前币种
  useEffect(() => {
    setNowTab(param?.name);
  }, [param]);

  //加载是否收藏
  useEffect(() => {
    loadiscollectData();
  }, []);

  //加载数据
  useEffect(() => {
    loadLeverListData();
  }, [orderindex]);

  //定时加载数据
  useEffect(() => {
    loadData();
    timer = setInterval(() => {
      loadData();
    }, 10000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  //定时加载数据
  useEffect(() => {
    timer = setInterval(() => {
      loadhuobigetHistoryData();
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  //当前币种修改后加载设置数据
  useEffect(() => {
    if (nowTab) {
      // 当币种变化时，重置所有选择状态，确保不会使用旧的选择
      setSelectedLeverage(0);
      setSelectedProfit(0);
      setSelectedLoss(0);
      setSelectedLeverageIndex(-1);
      setSelectedProfitIndex(-1);
      setSelectedLossIndex(-1);

      // 加载新币种的数据
      loadSetData();
    }
  }, [nowTab]);

  useEffect(() => {
    //判断是否弹窗
    const pop = location.search.replace("?isPop=", "");
    if (pop == "1") {
      setIsShow(true);
    }
  }, []);

  // 在组件末尾添加这个函数，用于初始化和更新价格显示
  useEffect(() => {
    if (
      !isMobile &&
      leverage.length > 0 &&
      leverSet1.length > 0 &&
      leverSet2.length > 0
    ) {
      // 只有在第一次加载数据时才设置初始值，确保已选择的值不被覆盖
      if (selectedLeverage === 0) {
        console.log("初始化杠杆倍数", leverage[0]?.num);
        setSelectedLeverageIndex(0);
        setSelectedLeverage(leverage[0]?.num || 3);
      }

      if (selectedProfit === 0) {
        console.log("初始化止盈", leverSet2[0]?.num);
        setSelectedProfitIndex(0);
        setSelectedProfit(leverSet2[0]?.num || 0);
      }

      if (selectedLoss === 0) {
        console.log("初始化止损", leverSet1[0]?.num);
        setSelectedLossIndex(0);
        setSelectedLoss(leverSet1[0]?.num || 0);
      }
    }
  }, [leverage.length, leverSet1.length, leverSet2.length]);

  // 添加一个函数用于更新价格显示
  function updateLeveragePrices() {
    if (!isMobile && coinListData[nowTab]?.close) {
      const openPrice = coinListData[nowTab]?.close;
      const leverageNum = selectedLeverage || 3;
      const profitPercent = selectedProfit || 0;
      const lossPercent = selectedLoss || 0;

      // 计算爆仓价
      let boomPriceValue = 0;
      if (type === 1) {
        boomPriceValue = openPrice * (1 - 1 / leverageNum + 0.005);
      } else {
        boomPriceValue = openPrice * (1 + 1 / leverageNum - 0.005);
      }

      // 计算止盈价
      let winPriceValue = 0;
      if (type === 1) {
        winPriceValue = openPrice * (1 + profitPercent / 100);
      } else {
        winPriceValue = openPrice * (1 - profitPercent / 100);
      }

      // 计算止损价
      let lossPriceValue = 0;
      if (type === 1) {
        lossPriceValue = openPrice * (1 - lossPercent / 100);
      } else {
        lossPriceValue = openPrice * (1 + lossPercent / 100);
      }

      // 更新状态
      setBoomPrice(boomPriceValue.toFixed(4));
      setWinPrice(winPriceValue.toFixed(4));
      setLossPrice(lossPriceValue.toFixed(4));
    }
  }

  // 添加一个useEffect专门用于监听价格变动
  useEffect(() => {
    if (!isMobile) {
      updateLeveragePrices();
    }
  }, [
    coinListData,
    type,
    selectedLeverage,
    selectedProfit,
    selectedLoss,
    nowTab,
  ]);

  return (
    <div className="min-h-screen bg-neutral-900 text-white revert-style">
      <AcendexLayout bottomBarIndex={3} theme="light">
        <div className={isMobile ? "" : "container mx-auto px-4 py-2"}>
          {isMobile ? (
            // 移动端布局 - 上下结构
            <div className="flex flex-col">
              {/* 顶部部分 */}
              <div>
                <TopBar
                  coinname={param.name}
                  iscollect={iscollect}
                  collectAdd={collectAdd}
                  collectDel={collectDel}
                />
              </div>

              {/* 交易信息和交易操作区 */}
              <div className="mb-3 overflow-hidden text-white">
                <TopText
                  setIsShowCoin={setIsShowCoin}
                  nowTab={nowTab}
                  coinListData={coinListData}
                />
              </div>

              <div className="grid grid-cols-2 gap-2">
                {/* 深度数据区域 */}
                <div className="mb-3 overflow-hidden">
                  <DataList huobigetHistory={huobigetHistory} />
                </div>

                {/* 交易操作区 */}
                <div className="mb-3 overflow-hidden">
                  <div className="pr-2">
                    <div className="grid grid-cols-2 mb-4">
                      <button
                        className={`py-2.5 text-sm font-medium transition-all ${
                          type === 1
                            ? "bg-green-600 text-black shadow-md"
                            : "bg-neutral-700 text-neutral-300 hover:bg-neutral-600"
                        }`}
                        onClick={() => setType(1)}
                      >
                        {translate(getText("看漲"))}
                      </button>
                      <button
                        className={`py-2.5  text-sm font-medium transition-all ${
                          type === 2
                            ? "bg-red-500 text-black shadow-md"
                            : "bg-neutral-700 text-neutral-300 hover:bg-neutral-600"
                        }`}
                        onClick={() => setType(2)}
                      >
                        {translate(getText("看跌"))}
                      </button>
                    </div>

                    <div className="mb-4 flex flex-col ">
                      <div className="flex justify-between md:flex-row flex-col items-center mb-2">
                        <div className="flex items-center justify-between">
                          <div className="text-neutral-400 text-sm">
                            {translate(getText("可用"))}
                          </div>
                          <div className="flex items-center">
                            <span className="text-neutral-300 text-sm mr-2">
                              {userInfo?.usdt || "0"} USDT
                            </span>
                          </div>
                        </div>
                        <button className="text-xs bg-green-600 text-black px-2.5 py-1 rounded-md hover:bg-green-500 transition-colors">
                          {translate(getText("充值"))}
                        </button>
                      </div>

                      <div className="flex items-center bg-neutral-700  p-2.5 mb-1 ">
                        <input
                          value={buyAmount}
                          onChange={(e) => setBuyAmount(e.target.value)}
                          type="number"
                          min="10"
                          step="0.01"
                          className="flex-grow min-w-0 bg-transparent border-none outline-none text-white text-sm"
                          placeholder={translate(getText("输入金额"))}
                        />
                        <button
                          className="shrink-0 text-primary text-sm font-medium"
                          onClick={() => {
                            setBuyAmount(userInfo?.usdt || "0");
                          }}
                        >
                          {translate(getText("全部"))}
                        </button>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="text-neutral-400 text-sm mb-2">
                        {translate(getText("杠杆倍數"))}
                      </div>
                      <div className="grid grid-cols-5 gap-2">
                        {leverage.map((item, index) => (
                          <div
                            key={index}
                            className={`px-1 py-1.5  text-center text-sm cursor-pointer transition-all ${
                              index === selectedLeverageIndex
                                ? "bg-primary text-black"
                                : "bg-neutral-700 text-neutral-300 hover:bg-neutral-600"
                            }`}
                            onClick={() => {
                              setSelectedLeverageIndex(index);
                              setSelectedLeverage(item.num);
                            }}
                          >
                            {item.num}X
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="flex justify-between items-center mb-2">
                        <div className="text-sm text-neutral-400">
                          {translate(getText("止盈/止损"))}
                        </div>
                        <div className="text-primary text-sm bg-primary/10 px-2.5 py-1 rounded-md">
                          40%
                        </div>
                      </div>
                    </div>

                    <div className="mb-5">
                      <div className="grid grid-cols-4 gap-2">
                        <div className="text-center py-1.5 bg-neutral-700 rounded-md text-neutral-300 text-xs hover:bg-neutral-600 cursor-pointer transition-colors">
                          20%
                        </div>
                        <div className="text-center py-1.5 bg-neutral-700 rounded-md text-neutral-300 text-xs hover:bg-neutral-600 cursor-pointer transition-colors">
                          40%
                        </div>
                        <div className="text-center py-1.5 bg-neutral-700 rounded-md text-neutral-300 text-xs hover:bg-neutral-600 cursor-pointer transition-colors">
                          60%
                        </div>
                        <div className="text-center py-1.5 bg-neutral-700 rounded-md text-neutral-300 text-xs hover:bg-neutral-600 cursor-pointer transition-colors">
                          100%
                        </div>
                      </div>
                    </div>

                    <button
                      className={`w-full py-3  text-black font-medium text-base cursor-pointer transition-all ${
                        type === 1
                          ? "bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400"
                          : "bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400"
                      }`}
                      onClick={() => {
                        const amount = parseFloat(buyAmount || "0");
                        const minAmount = 10;

                        if (amount < minAmount) {
                          Toast.show({
                            content: `${translate(
                              getText("最低投资额")
                            )} ${minAmount}`,
                          });
                          return;
                        }

                        buyCoin({
                          isnew: 1, // 新增
                          coinname: nowTab?.toUpperCase() + "/USDT",
                          amount: amount,
                          tzfx: type, // 1 多 2 空
                          leverage: selectedLeverage,
                          openprice: coinListData[nowTab]?.close,
                          loss: lossPrice !== "--" ? lossPrice : "0",
                          win: winPrice !== "--" ? winPrice : "0",
                          boomPrice: boomPrice !== "--" ? boomPrice : "0",
                        });
                      }}
                    >
                      {translate(getText("確認下單"))}
                    </button>
                  </div>
                </div>
              </div>

              {/* 持仓/历史记录 - 占据整行 */}
              <div className="bg-neutral-800 rounded-lg mb-16 shadow-card overflow-hidden">
                <div className="hidden p-3">
                  <div className="flex bg-neutral-700 rounded-lg p-1 mb-3">
                    <button
                      className={`flex-1 py-2 text-center rounded-md text-sm transition-colors 
                        ${
                          orderindex === 1
                            ? "bg-primary text-black"
                            : "text-neutral-400"
                        }`}
                      onClick={() => setorderindex(1)}
                    >
                      {translate(getText("持倉"))}
                    </button>
                    <button
                      className={`flex-1 py-2 text-center rounded-md text-sm transition-colors 
                        ${
                          orderindex === 2
                            ? "bg-primary text-black"
                            : "text-neutral-400"
                        }`}
                      onClick={() => setorderindex(2)}
                    >
                      {translate(getText("已成交"))}
                    </button>
                  </div>

                  {/* 这里只是一个示例，具体内容将由OrderList组件渲染 */}
                </div>
                <OrderList
                  closeorder={closeorder}
                  addnumFun={addnum}
                  strutcnumFun={strutcnum}
                  editLossWinFun={editLossWin}
                  coinListData={coinListData}
                  orderindex={orderindex}
                  setorderindex={setorderindex}
                  nowTab={nowTab}
                  leverorders={leverorders}
                />
              </div>
            </div>
          ) : (
            // 桌面端布局 - 左右结构
            <div className="grid grid-cols-12 gap-4">
              {/* 左侧内容区域 */}
              <div className="col-span-8">
                <div className="mb-2">
                  <TopBar
                    coinname={param.name}
                    iscollect={iscollect}
                    collectAdd={collectAdd}
                    collectDel={collectDel}
                  />
                </div>

                <div className="bg-neutral-800 rounded-lg mb-3 shadow-card overflow-hidden">
                  <TopText
                    setIsShowCoin={setIsShowCoin}
                    nowTab={nowTab}
                    coinListData={coinListData}
                  />
                </div>
                <div className="bg-neutral-800 rounded-lg mb-3 shadow-card overflow-hidden">
                  <DataList huobigetHistory={huobigetHistory} />
                </div>

                <div className="bg-neutral-800 rounded-lg mb-3 shadow-card overflow-hidden">
                  <OrderList
                    closeorder={closeorder}
                    addnumFun={addnum}
                    strutcnumFun={strutcnum}
                    editLossWinFun={editLossWin}
                    coinListData={coinListData}
                    orderindex={orderindex}
                    setorderindex={setorderindex}
                    nowTab={nowTab}
                    leverorders={leverorders}
                  />
                </div>
              </div>

              {/* 右侧交易面板 - 桌面版 */}
              <div className="col-span-4">
                <div className="bg-neutral-800 rounded-lg p-4 shadow-card mt-2">
                  <div className="flex justify-between items-center mb-4">
                    <p className="text-white text-lg font-bold">
                      {type === 1
                        ? translate(getText("看漲"))
                        : translate(getText("看跌"))}{" "}
                      {nowTab?.toUpperCase() + "/USDT"}
                    </p>
                  </div>

                  <div className="mb-4">
                    <div className="text-neutral-400 text-sm mb-1">
                      {translate(getText("最新價格"))}
                    </div>
                    <div className="text-xl font-bold text-white">
                      {coinListData[nowTab]?.close} USDT
                    </div>
                  </div>

                  <div className="bg-neutral-700/50 rounded-lg p-3 mb-4">
                    <div className="flex justify-between items-center mb-2">
                      <p className="text-neutral-400 text-sm">
                        {translate(getText("方向"))}
                      </p>
                      <div className="flex gap-2">
                        <button
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                            type === 1
                              ? "bg-green-600 text-black shadow-md"
                              : "bg-neutral-600/70 text-neutral-300 hover:bg-neutral-600"
                          }`}
                          onClick={() => setType(1)}
                        >
                          {translate(getText("看漲"))}
                        </button>
                        <button
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                            type === 2
                              ? "bg-red-600 text-white shadow-md"
                              : "bg-neutral-600/70 text-neutral-300 hover:bg-neutral-600"
                          }`}
                          onClick={() => setType(2)}
                        >
                          {translate(getText("看跌"))}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="flex justify-between items-center mb-2">
                      <div className="text-neutral-400 text-sm">
                        {translate(getText("保证金"))} (USDT)
                      </div>
                      <div className="text-neutral-400 text-sm">
                        {translate(getText("可用"))}:{" "}
                        <span className="text-neutral-300">
                          {userInfo[0]?.usdt || "0.0000"}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center bg-neutral-700/50 rounded-lg p-2 mb-1 focus-within:ring-1 focus-within:ring-primary">
                      <input
                        value={buyAmount}
                        onChange={(e) => setBuyAmount(e.target.value)}
                        type="number"
                        min="10"
                        step="0.01"
                        className="flex-grow bg-transparent border-none outline-none text-white"
                        placeholder={translate(getText("请输入保证金金额"))}
                      />
                      <button
                        className="text-primary font-medium px-2 hover:text-primary-light transition-colors"
                        onClick={() => {
                          setBuyAmount(userInfo[0]?.usdt || "0");
                        }}
                      >
                        {translate(getText("全部"))}
                      </button>
                    </div>
                    <div className="text-neutral-500 text-xs pl-1">
                      {translate(getText("≈"))}{" "}
                      {(
                        parseFloat(buyAmount || "0") *
                        (hysetInfo?.usdtcnyrate || 0)
                      ).toFixed(4)}{" "}
                      CNY
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="text-neutral-400 text-sm mb-2">
                      {translate(getText("杠杆倍數"))}
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {leverage.map((item, index) => (
                        <div
                          key={index}
                          className={`px-4 py-2 rounded-lg text-center text-sm font-medium cursor-pointer transition-all ${
                            index === selectedLeverageIndex
                              ? "bg-primary text-white shadow-md"
                              : "bg-neutral-700/50 text-neutral-300 hover:bg-neutral-700"
                          }`}
                          onClick={() => {
                            setSelectedLeverageIndex(index);
                            setSelectedLeverage(item.num);
                          }}
                        >
                          {item.num}X
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <div className="text-neutral-400 text-sm mb-2">
                        {translate(getText("止盈"))}
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {leverSet2.map((item, index) => (
                          <div
                            key={index}
                            className={`px-3 py-2 rounded-lg text-center text-sm font-medium cursor-pointer transition-all ${
                              index === selectedProfitIndex
                                ? "bg-primary text-white shadow-md"
                                : "bg-neutral-700/50 text-neutral-300 hover:bg-neutral-700"
                            }`}
                            onClick={() => {
                              setSelectedProfitIndex(index);
                              setSelectedProfit(item.num);
                            }}
                          >
                            {item.num}%
                          </div>
                        ))}
                      </div>
                    </div>
                    <div>
                      <div className="text-neutral-400 text-sm mb-2">
                        {translate(getText("止損"))}
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {leverSet1.map((item, index) => (
                          <div
                            key={index}
                            className={`px-3 py-2 rounded-lg text-center text-sm font-medium cursor-pointer transition-all ${
                              index === selectedLossIndex
                                ? "bg-primary text-white shadow-md"
                                : "bg-neutral-700/50 text-neutral-300 hover:bg-neutral-700"
                            }`}
                            onClick={() => {
                              setSelectedLossIndex(index);
                              setSelectedLoss(item.num);
                            }}
                          >
                            {item.num}%
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="bg-neutral-700/30 p-3 rounded-lg">
                      <div className="text-neutral-400 text-sm mb-1">
                        {translate(getText("止盈價"))}
                      </div>
                      <div className="text-white font-medium">{winPrice}</div>
                    </div>
                    <div className="bg-neutral-700/30 p-3 rounded-lg">
                      <div className="text-neutral-400 text-sm mb-1">
                        {translate(getText("止損價"))}
                      </div>
                      <div className="text-white font-medium">{lossPrice}</div>
                    </div>
                  </div>

                  <div className="mb-5 bg-neutral-700/30 p-3 rounded-lg">
                    <div className="text-neutral-400 text-sm mb-1">
                      {translate(getText("强平价格"))}
                    </div>
                    <div className="text-white font-medium">{boomPrice}</div>
                  </div>

                  <button
                    className={`w-full py-3 rounded-lg text-black font-bold shadow-md text-base cursor-pointer transition-all ${
                      type === 1
                        ? "bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400"
                        : "bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400"
                    }`}
                    onClick={() => {
                      const amount = parseFloat(buyAmount || "0");
                      const minAmount = 10;

                      if (amount < minAmount) {
                        Toast.show({
                          content: `${translate(
                            getText("最低投资额")
                          )} ${minAmount}`,
                        });
                        return;
                      }

                      buyCoin({
                        isnew: 1, // 新增
                        coinname: nowTab?.toUpperCase() + "/USDT",
                        amount: amount,
                        tzfx: type, // 1 多 2 空
                        leverage: selectedLeverage,
                        openprice: coinListData[nowTab]?.close,
                        loss: lossPrice !== "--" ? lossPrice : "0",
                        win: winPrice !== "--" ? winPrice : "0",
                        boomPrice: boomPrice !== "--" ? boomPrice : "0",
                      });
                    }}
                  >
                    {translate(getText("確認下單"))}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* 币种选择弹窗 */}
        <CoinPopup
          isShowCoin={isShowCoin}
          setIsShowCoin={setIsShowCoin}
          coinListData={coinListData}
          ctmarketlist={ctmarketlist}
          collectlist={collectlist}
          index={2}
        />

        {/* 订单底部弹窗 - 只在移动端的TopBuy被点击时显示 */}
        {!isMobile && (
          <OrderPopup
            leverSet1={leverSet1}
            leverSet2={leverSet2}
            leverage={leverage}
            type={type}
            setyqsy={0}
            setType={setType}
            userInfo={userInfo}
            hysetInfo={hysetInfo}
            buyCoin={buyCoin}
            isShowOrder={isShowOrder}
            setIsShowOrder={setIsShowOrder}
            nowTab={nowTab}
            coinListData={coinListData}
            ctmarketlist={ctmarketlist}
            index={1}
          />
        )}

        {/* 移动端底部交易按钮 - 隐藏，因为已经在右侧显示交易面板 */}
        {false && isMobile && (
          <div className="fixed bottom-16 left-0 right-0 px-3 pb-3 z-10">
            <TopBuy setIsShowOrder={setIsShowOrder} setType={setType} />
          </div>
        )}
      </AcendexLayout>
    </div>
  );
}
